module.exports = __webpack_public_path__ + "static/media/manguera-verde.79e1cc36.svg";